export default {
    notUsed: -1,
    requesting: 0,
    successful: 1,
    failed: 2,
};